import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {Divider, Text} from 'wix-ui-tpa/cssVars'
import {useCurrencyFormatter} from '../../../../../../../../commons/hooks/currency'
import {getWholeTableReservationPrice, isPlaceReservableAsWhole} from '../../../../../selectors/seating/place'
import {classes} from './whole-element-reservation.st.css'
import {WholeElementReservationProps} from '.'

export const WholeElementReservation = ({
  place,
  basketView,
  inDescription,
  showAccessibilityMode,
  event,
  noServiceFee,
}: WholeElementReservationProps) => {
  const {t} = useTranslation()
  const {getFormattedMoney, getTicketPriceText} = useCurrencyFormatter()

  if (!isPlaceReservableAsWhole(place)) {
    return null
  }

  return (
    <div className={basketView || inDescription || showAccessibilityMode ? classes.container : ''}>
      <Divider className={classes.divider} />
      <Text className={classes.tableReservation}>
        {t('seating_tableReservation', {
          price: getWholeTableReservationPrice({event, place, t, getFormattedMoney, getTicketPriceText, noServiceFee}),
        })}
      </Text>
    </div>
  )
}
